export const FEATURES = {
  LAWYER_INDEXATION: 'lawyerIndexation',
  MANAGER_INDEXATION: 'managerIndexation',
  COURT_MANAGER_ASSIGNMENT: 'courtManagerAssignment',
  LAWYER_ASSIGNMENT: 'lawyerAssignment',
  LAWYER_JUDGEMENT_ADD: 'lawyerJudgementAdd',
  OPPOSING_PARTY: 'opposingParty',
  MANAGER_JUDGEMENT_ADD: 'managerJudgementAdd',
  SEARCH_BAR: 'searchBar',
  EXPERT_REPORT: 'expertReport',
  LEGAL_PROCEEDING_STEP: 'legalProceedingStep',
  SUED_PARTY: 'suedParty',
  JUDGEMENT_ON_MERITS: 'judgementOnMerits',
  JUDGEMENT_APPEAL: 'judgementAppeal',
  EXPERT_REPORT_SAGIS_EVALUATION: 'expertReportSagisEvaluation',
  MIXED_CLAIM: 'mixedClaim',
  JUDGEMENT_ADD_EXPERT_INFO: 'judgementAddExpertInfo',
  CLAIM_REJECTION_REASONS: 'claimRejectionReasons',
  DECEASED_VICTIMS: 'deceasedVictims',
  FEE_NOTE: 'feeNote',
  NOTIFICATION: 'notification',
  MANAGER_OPENING: 'managerOpening',
  FRAUDE_CORPO: 'fraudeCorpo',
  CIVIL_PROCEEDING: 'civilProceeding',
  DISCLAIMER_WARRANTY: 'disclaimerWarranty',
  PROVISION: 'provision',
  JUDGEMENT_ON_MERITS_CONTESTATION: 'judgementOnMeritsContestation',
  ADD_MULTIPLE_JUDGEMENT_ADD: 'addMultipleJudgementAdd',
  ADD_LAWYER_JUDICIARY_PROCESS: 'addLawyerJudiciaryProcess',
  ENABLE_JUDICIARY_STEPS: 'enableJudiciarySteps',
  ADD_SUPPORT_DOCUMENTS: 'addSupportDocuments',
  ASSIGNMENT_CLAIM: 'assignmentClaim',
  ADD_MULTIPLE_JOM: 'addMultipleJom',
  EXPERT_INTEGRATION: 'expertIntegration',
  EXPERT_INTEGRATION_ACCOUNTING: 'expertIntegrationAccounting',
  EXPERT_INTEGRATION_MECHANIC: 'expertIntegrationMechanic',
  LAWYER_REJECTED_CLAIM_UPDATE: 'lawyerRejectedClaimUpdate',
  ASSIGNMENT_MANAGER_TOWN: 'assignmentManagerTown',
  ASSIGNMENT_MULTIPLE_LAWYERS: 'assignmentMultipleLawyers',
  SEARCH_BY_CLAIM_NUMBER: 'searchClaimByClaimNumber',
  MANAGE_CLAIM_BY_MANAGER: 'manageClaimByManager',
  MANAGER_LOCK_CLAIM: 'managerLockClaim',
  UPDATE_CLAIM_OPENING_MANAGER: 'updateClaimOpeningManager',
  ADMINISTRATION_MANAGER: 'administrationManager',
  ATTRIBUTION_INBOXES_MANAGER: 'attributionInboxesManager',
  OPEN_CLAIM_BY_OPENING_MANAGER: 'openClaimByOpeningManager',
  UPDATE_CLAIM_COURT_MANAGER: 'updateClaimCourtManager',
  MIGRATION_CLAIM_INFO: 'migrationClaimInfoSagis',
  ASSIGNMENT_JURISDICTION_LAWYER: 'assignmentJurisdictionLawyer',
  CLAIM_NATURE_TRANSACTION: 'claimNatureTransaction',
  FRAUD_INFO: 'fraudInfo',
  AUTOMATIC_LOCK_CLAIM: 'automaticLockClaim',
  JUDGEMENT_ON_MERITS_INFO: 'judgementOnMeritsInfo',
  REGULATION_V2: 'regulationV2',
  GET_DAHIR_AMOUNT_V2: 'getDahirAmountV2',
  REGULATION_WORKFLOW_VALIDATION: 'regulationWorkflowValidation',
  UPDATE_VALIDATED_CLAIM_OPENING_MANAGER: 'updateValidatedClaimOpeningManager',
  REGULATION_MATERIAL: 'regulationMaterial',
  BILLING_INFO_FEE_NOTE: 'billingInfoFeeNote',
  REASONS_FOR_NON_COMPENSATION: 'reasonsForNonCompensation',
  TRACKING_ACTIONS_USER: 'trackingActionsUser',
  EVOLUTIONS_FEE_NOTE: 'evolutionsFeeNote',
  BILLING_INFO_FEE_NOTE_EXPERT: 'billingInfoFeeNoteExpert',
  TRAITEMENT_IMAGINE_DOC: 'traitementImagineDoc',
  BASIC_MANAGEMENT: 'basicManagement',
  STATUS_MANAGEMENT: 'statusManagement',
  PRIORITY_CLAIM: 'priorityClaim',
  DISPLAY_TRACKING_ICON: 'displayTrackingIcon',
  ADD_STAKE_HOLDER: 'addStakeHolder',
  INSTRUCTIONS: 'instructions',
  NEW_CLAIM_RECAP_GO: 'newRecapClaimGo',
  INCOME_CERTIFICATE: 'incomeCertificate',
  ATTRIBUTION_INBOXES_TRANSACTION_MANAGER:
    'attributionInboxesTransactionManager',
  TRANSACTION: 'transaction',
  ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST:
    'assignmentJurisdictionLawyerRequest',
  ADD_COST_SAGIS: 'addCostSagis',
  ADD_COST_GPO_OPENING_CLAIM: 'addCostGpoOpeningClaim',
  IS_VICTIM_EXCLUDED_FROM_COVERAGE: 'isVictimExcludedFromCoverage',
  INBOXES_TRANSACTION_MANAGER: 'inboxesTransactionManager',
  ADD_FEE_NOTE_OPENING_MANAGER: 'addFeeNoteOpeningManager',
  BASIC_MANAGEMENT_REGULATION: 'basicManagementRegulation',
  PLATFORM_MANAGER: 'platformManager',
  PLATFORM_MANAGER_INTERVENANT: 'platformManagerIntervenant',
  TRANSACTION_V2: 'transactionV2',
  EVOLUTION_P1: 'activateEvolutionsP1',
  EVOLUTION_P3: 'activateEvolutionsP3',
  EVOLUTION_P4: 'activateEvolutionsP4',
  DOCUMENTUM_JUDICIARY_STEPS: 'documentumJudiciarySteps',
  LAWYER_INBOXES: 'lawyerInboxes',
  GET_LEGAL_PROCEEDING: 'refactoGetLegalProceeding',
  UPDATE_VICTIM_BASIC_MANAGEMENT: 'updateVictimBasicManagement',
  RESOLVE_EXPERTISE_REPORT_VALUES: 'resolveExpertiseReportValues',
  RNVA: 'rnva',
  HEALTH_CHECK_POLLING: 'healthCheckPolling',
  COURT_CALENDAR: 'courtCalendar',
  LIMIT_INVOICE_DATE: 'limitInvoiceDate',
  NEW_LAW_DAHIR: 'newLawDahir',
  GSJ_OPTIONAL_DATA: 'gsjOptionalData',
  OPENING_BY_USAGE: 'openingByUsage',
  FUSION: 'fusion',
  REBRANDING_EDITIQUE: 'rebrandingEditique',
} as const;
